import { converToUnit } from '../utils/helpers.js';

export default {
    computed: {
        dimensionData() {
            return {
                height: this.height,
                maxHeight: this.maxHeight,
                maxWidth: this.maxWidth,
                minHeight: this.minHeight,
                minWidth: this.minWidth,
                width: this.width,
            };
        },
        dimensionStyles() {
            return {
                height: converToUnit(this.height),
                maxHeight: converToUnit(this.maxHeight),
                maxWidth: converToUnit(this.maxWidth),
                minHeight: converToUnit(this.minHeight),
                minWidth: converToUnit(this.minWidth),
                width: converToUnit(this.width),
            };
        },
    },
    props: {
        /**
         * Определяет высоту, числовые значения приводятся к пикселям, строковые остаются как есть
         */
        height: {
            type: [Number, String],
            default: null,
        },
        /**
         * Определяет максимальную высоту, числовые значения приводятся к пикселям, строковые остаются как есть
         */
        maxHeight: {
            type: [Number, String],
            default: null,
        },
        /**
         * Определяет максимальную ширину, числовые значения приводятся к пикселям, строковые остаются как есть
         */
        maxWidth: {
            type: [Number, String],
            default: null,
        },
        /**
         * Определяет минимальную высоту, числовые значения приводятся к пикселям, строковые остаются как есть
         */
        minHeight: {
            type: [Number, String],
            default: null,
        },
        /**
         * Определяет минимальную ширину, числовые значения приводятся к пикселям, строковые остаются как есть
         */
        minWidth: {
            type: [Number, String],
            default: null,
        },
        /**
         * Определяет ширину, числовые значения приводятся к пикселям, строковые остаются как есть
         */
        width: {
            type: [Number, String],
            default: null,
        },
    },
};
